import { createSlice } from "@reduxjs/toolkit";
import { ShareLinksByEmail } from "../API/ShareLinks";

const initialState = {
    shareLinkData: [],
    loading: false,
    error: null,
};

const ShareLinksSlice = createSlice({
  name: "ShareLinks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ShareLinksByEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ShareLinksByEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.shareLinkData = action.payload;
      })
      .addCase(ShareLinksByEmail.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
  },
});

export default ShareLinksSlice.reducer;